var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", {
    staticClass: "page p-home",
    attrs: {
      type: "full"
    }
  }, [_c("d2-grid-layout", _vm._b({
    on: {
      "layout-updated": _vm.layoutUpdatedHandler
    }
  }, "d2-grid-layout", _vm.layout, false), _vm._l(_vm.layout.layout, function (item) {
    return _c("d2-grid-item", _vm._b({
      key: item.i,
      on: {
        resize: _vm.resizeHandler,
        move: _vm.moveHandler,
        resized: _vm.resizedHandler,
        moved: _vm.movedHandler
      }
    }, "d2-grid-item", item, false), [_c("div", {
      staticClass: "chart-item"
    }, [item.i === "0" ? [_c("NewUserChart")] : _vm._e(), item.i === "1" ? [_c("ActiveHouseChart", {
      attrs: {
        cityList: _vm.cityList
      }
    })] : _vm._e(), item.i === "7" ? [_c("NewHouseChart", {
      attrs: {
        cityList: _vm.cityList
      }
    })] : _vm._e(), item.i === "2" ? [_c("OperationChart", {
      ref: "operationChart",
      refInFor: true
    })] : _vm._e(), item.i === "6" ? [_c("div", {
      staticClass: "chart-header"
    }, [_c("h2", [_vm._v("复杂审核占比")]), _c("div", [_c("el-radio-group", {
      attrs: {
        size: "small"
      },
      on: {
        change: _vm.getAnalysisHouseComplexAudit
      },
      model: {
        value: _vm.houseComplexAuditTimeType,
        callback: function callback($$v) {
          _vm.houseComplexAuditTimeType = $$v;
        },
        expression: "houseComplexAuditTimeType"
      }
    }, [_c("el-radio-button", {
      attrs: {
        label: 0
      }
    }, [_vm._v("当天")]), _c("el-radio-button", {
      attrs: {
        label: 1
      }
    }, [_vm._v("近7天")]), _c("el-radio-button", {
      attrs: {
        label: 2
      }
    }, [_vm._v("近一个月")]), _c("el-radio-button", {
      attrs: {
        label: 3
      }
    }, [_vm._v("近3个月")])], 1)], 1)]), _c("div", {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: _vm.getAnalysisHouseComplexAuditLoading,
        expression: "getAnalysisHouseComplexAuditLoading"
      }],
      staticClass: "chart-container",
      attrs: {
        id: "container-house-complex-audit"
      }
    })] : _vm._e(), item.i === "3" ? [_c("SessionsNumChart", {
      attrs: {
        cityList: _vm.cityList
      }
    })] : _vm._e(), item.i === "4" ? [_c("div", {
      staticClass: "chart-header"
    }, [_c("h2", [_vm._v("房东转化")]), _c("div", [_vm.inviterTopTotal ? _c("span", {
      staticStyle: {
        "margin-right": "20px"
      }
    }, [_vm._v("总数：" + _vm._s(_vm.inviterTopTotal.value))]) : _vm._e(), _c("el-radio-group", {
      attrs: {
        size: "small"
      },
      on: {
        change: _vm.getInviterTopCount
      },
      model: {
        value: _vm.inviterTopTimeType,
        callback: function callback($$v) {
          _vm.inviterTopTimeType = $$v;
        },
        expression: "inviterTopTimeType"
      }
    }, [_c("el-radio-button", {
      attrs: {
        label: 1
      }
    }, [_vm._v("近7天")]), _c("el-radio-button", {
      attrs: {
        label: 2
      }
    }, [_vm._v("近一个月")]), _c("el-radio-button", {
      attrs: {
        label: 3
      }
    }, [_vm._v("近3个月")])], 1)], 1)]), _c("div", {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: _vm.getInviterTopCountLoading,
        expression: "getInviterTopCountLoading"
      }],
      staticClass: "chart-container",
      attrs: {
        id: "container-inviter-top"
      }
    })] : _vm._e(), item.i === "5" ? [_c("CommunityActivity", {
      ref: "communityActivity",
      refInFor: true
    })] : _vm._e(), item.i === "8" ? [_c("CommunityExpo", {
      ref: "communityActivity",
      refInFor: true
    })] : _vm._e(), item.i === "9" ? [_c("UserSafetyChart", {
      ref: "userSafetyChart",
      refInFor: true
    })] : _vm._e(), item.i === "10" ? [_c("FraudSessionsChart", {
      ref: "fraudSessionsChart",
      refInFor: true
    })] : _vm._e(), item.i === "11" ? [_c("FraudResolutionChart", {
      ref: "FraudResolution",
      refInFor: true
    })] : _vm._e(), item.i === "12" ? [_c("FraudulentPlatformChart", {
      ref: "FraudulentPlatformChart",
      refInFor: true
    })] : _vm._e()], 2)]);
  }), 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };